// base
import React, { Component } from "react";

// components
import { Button } from "..";
import { substring, getValueByDecimals } from "../../../helper";

class ContractOverview extends Component {
  render() {
    const { contract, transactionCnt } = this.props;
    const {
      totalSupply,
      transferCnt,
      symbol,
      creator,
      createTx,
      decimals,
      tokenType,
    } = contract;
    return (
      <div className="responsive_table">
        <table className="table_type03" style={{ minWidth: "450px" }}>
          <colgroup>
            <col width="200px" />
            <col />
          </colgroup>
          <tbody>
            {tokenType === "ARC20" && (
              <tr>
                <th>Max Total Supply:</th>
                <td>
                  {getValueByDecimals(totalSupply, decimals).toLocaleString()}{" "}
                  {symbol}
                </td>
              </tr>
            )}

            <tr>
              <th>Transactions:</th>
              <td>{transactionCnt}</td>
            </tr>
            {tokenType !== null && (
              <tr>
                <th>Transfers:</th>
                <td>{transferCnt}</td>
              </tr>
            )}

            <tr>
              <th>Creator:</th>
              <td>
                <Button
                  color="blue"
                  link={`/account/${creator}`}
                  tooltip={creator}
                >
                  {substring(creator, 10)}
                </Button>
              </td>
            </tr>
            <tr>
              <th>Create Transaction:</th>
              <td>
                <Button
                  color="blue"
                  link={`/transaction/${createTx}`}
                  tooltip={createTx}
                >
                  {substring(createTx, 10)}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractOverview;
